import stringUtils from '../../utils/stringUtils';
import { Box, Icon, Image } from '@zillow/constellation-10';
import { IconHomeTypeFilled } from '@zillow/constellation-icons';
import { AvatarGroup } from '@zg-rentals/satellite-components';
import { thumbnailBackgroundStyles, thumbnailBorderRadius, thumbnailSizeStyles } from './styles';

type Props = {
  avatarName?: string | null;
  photoUrl?: string | null;
};

export default function PropertyThumbnailWithAvatar({ avatarName = '', photoUrl }: Props) {
  const capitalizedAvatarName = avatarName ? stringUtils.capitalize(avatarName) : '';

  return (
    <Box css={{ position: 'relative', alignSelf: 'flex-start', display: 'flex' }}>
      {photoUrl ? (
        <Image
          src={photoUrl}
          alt="Property thumbnail"
          width={56}
          height={56}
          css={{ overflow: 'hidden', flexShrink: 0, ...thumbnailBorderRadius, ...thumbnailSizeStyles }}
        />
      ) : (
        <Box
          css={{
            ...thumbnailBorderRadius,
            ...thumbnailBackgroundStyles,
            ...thumbnailSizeStyles,
          }}
        >
          <Icon css={{ color: 'icon.subtle' }} render={<IconHomeTypeFilled />} size="lg" />
        </Box>
      )}

      <Box css={{ position: 'absolute', right: '-8px', bottom: '-8px' }}>
        <AvatarGroup participants={[capitalizedAvatarName]} variant="compact" />
      </Box>
    </Box>
  );
}
